<div class="centered-vertically-column-container column-gap-1p25 height-80vh">
  <app-all-icons [iconNameAndStyling]="iconNameAndStyling"></app-all-icons>
  <span class="black-12 title-3 bold600">{{ title }}</span>
  <div class="centered-vertically-column-container column-gap-2p5 width-23">
    <div class="centered-vertically-column-container column-gap-0p5">
      <app-input
        data-qa="empty-state-create-name-input"
        class="centered-text width-100pcnt"
        [placeholder]="placeholder"
        [(input)]="inputName"
      >
      </app-input>
      <app-button
        data-qa="empty-state-create-button"
        class="create-button-wrapper"
        [size]="'large'"
        [type]="'accent'"
        [bordersSquaredShape]="'full'"
        (buttonClick)="createButtonClick.emit(inputName)"
      >
        Create
      </app-button>
    </div>
    <div class="text-center line-height-150">{{description | upperCaseFirstLetter}}</div>
  </div>
</div>
